<template>
  <div class="stand-input-wrapper stand-input">
    <div v-if="myType === 'input'" class="stand-input-core">
      <input
        :disabled="disabled"
        type="text"
        class="cus-input"
        @input="handleInputChange"
        v-model="myData"
      />
      <div v-if="unit" class="unit">{{ unit }}</div>
    </div>
    <div v-if="myType === 'select'" class="stand-select-core">
      <el-select
        v-model="myData"
        placeholder=""
        :disabled="disabled"
        @change="handleChange"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
// import { checkNumber, checkIntergerNumber } from './utils';
export default {
  props: {
    selectOptions: {
      type: Array,
      default: () => []
    },
    myType: {
      type: String,
      default: 'input'
    },
    unit: {
      type: String,
      default: ''
    },
    value: {
      require: true
    },
    onlyNumber: {
      type: Boolean,
      default: false
    },
    interger: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myData: null
    };
  },
  watch: {
    value: {
      handler(val) {
        this.myData = val;
      },
      immediate: true
    },
    myData: {
      handler(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val);
    },
    handleInputChange(e) {
      if (this.onlyNumber) {
        if (this.interger) {
          const newValue = e.target.value.replace(/[^0-9]/g, '');
          this.myData = newValue;
          return;
        }

        const resPoint = this.myData.split('').reduce((acc, c) => {
          if (c === '.') {
            acc++;
          }
          return acc;
        }, 0);

        if (resPoint > 1 && e.data === '.') {
          const value = e.target.value?.substr(0, this.myData.length - 1);
          this.myData = value;
        } else {
          if (resPoint === 1) {
            const newValue = e.target.value.replace(/[^0-9.]/g, '');
            const lastNums = newValue.split('.');
            if (lastNums[1].length > this.precision) {
              const value = e.target.value?.substr(0, this.myData.length - 1);
              const newValue = value.replace(/[^0-9.]/g, '');
              this.myData = newValue;
            } else {
              this.myData = newValue;
            }
          } else {
            const newValue = e.target.value.replace(/[^0-9.]/g, '');
            this.myData = newValue;
          }
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.stand-input-wrapper {
  display: inline-block;
  position: relative;
}
.stand-input-core {
  display: flex;
  align-content: center;

  input[disabled] {
    color: #c0c4cc;
  }
}
.cus-input {
  border: none;
  width: 100%;
  padding-right: 15px;
  height: 24px;
  outline: none;
  font-size: 14px;
  background-color: #fff;
}
.unit {
  position: absolute;
  right: 5px;
  top: 50%;
  font-size: 12px;
  color: #999;
  transform: translateY(-50%);
}
</style>

<style lang="less">
.stand-select-core {
  position: relative;
  top: 1px;
  height: 100%;
  .el-select {
    .el-input--suffix .el-input__inner {
      padding-right: 0px !important;
    }
    .el-input__inner {
      width: 100%;
      padding-left: 0px;
    }
    .el-input__suffix {
      display: none;
    }
    .el-input {
      input {
        border: none;
        outline: none;
        font-size: 14px;
        width: 100%;
        height: 24px;
        line-height: 24px;
      }
    }
  }
}
</style>
